import { AdminAccountService, DavisAlertService } from '@DavisDigital/davisdigitalfrontend.module';

enum Screen {
	PRE_IMPORT,
	REVIEW,
	POST_IMPORT
}
type dryRunOrImport = 'dryRun'|'import';

class AdminAccountImportController {
	public hasErrors = false;
	public loading = false;
	public importState = {};
	public dryRunResults:any[];
	public Screen = Screen; //makes enum accessible to view
	public currentScreen = Screen.PRE_IMPORT;
	public importAction: dryRunOrImport = 'dryRun';
	public formattedResults = [];
	public file;
	public isFieldMissing = false;
	
	public selectedAccounts;
	public accountIDs = [];
	
	// @ngInject
	constructor(
		private adminAccountService:AdminAccountService,
		private davisAlertService: DavisAlertService,
		private $window			: ng.IWindowService,
	){}
	
	public back(){
		this.currentScreen = Screen.PRE_IMPORT;
		this.file = null;
	}
	
	public importFile(dryRun = true){
		this.loading = true;
		if(dryRun){
			this.file = (<HTMLInputElement>document.getElementById('fileUpload')).files[0];
		}
		
		this.adminAccountService.importAccounts(this.file, dryRun)
		.then(res => {

			if(dryRun && res.result && res.result.formattedAccounts){
				if(res.result.checkRequiredFieldStatus) {
					this.davisAlertService.error('Missing Fields:Please fill all the required fields');
					this.isFieldMissing = true;
					this.loading = false;
					return;
				}
				this.formatResults(res.result, 'dryRun');
				this.dryRunResults = res.result.formattedAccounts;
				this.currentScreen = this.currentScreen == Screen.PRE_IMPORT ? Screen.REVIEW : Screen.POST_IMPORT;	
				this.loading = false;
				this.davisAlertService.success('Records staged succesfully.');
				
				return;
			}
			
			if(!dryRun && res.result && res.result.formattedAccounts){
				this.currentScreen = Screen.POST_IMPORT;
				
				//populate account properties for bulk permission
				this.selectedAccounts = res.result.formattedAccounts;
				for(let account in this.selectedAccounts) {
					this.accountIDs.push(this.selectedAccounts[account].accountID);
				}
				
				return;
			}
			
			this.davisAlertService.error('An unexpected errror occurred. Please review your CSV file.');
		}).finally(()=>{
			this.loading = false;
		});
	}
	
	public handleBulkPermissionCallback = () => {
		console.log("all set from import");
		this.davisAlertService.success('Records imported succesfully.');
		
		this.$window.location.href = "/dashboard/accounts";
	}
	
	public formatResults(results:any, resultType:dryRunOrImport){
		let formattedArray = [];
		
		if(resultType == 'dryRun'){
			let totalResults = results.formattedAccounts;
			
			let displayPropertiesMap = {
				username: 'User Name',
				firstname: 'First Name',
				lastname: 'Last Name', 
				emailaddress: 'Email',
				accountrelationshiprolename: 'Account Type',
				password: 'Password',
				tags: 'Tags'
			}
			let canContinue = false;
			for(let record of totalResults){
			
				record['errorColumns'] = Object.keys( record['validation'] ).filter( k => !record['validation'][k] );
				
				//records that were csv errors do not have a key for newEntityFlag, only inserts and updates do
				//for frontend purposes "isUpdated" means the record would do either upsert action, should be false only if it would error
				record['isNewEntity'] = ( ( record['newEntityFlag'] || 0 ) && record['valid'] );
				record['isUpdated'] = !record['valid'];
				
				let errorMessage = '';
				let indicative = ' is '; //Y column *IS* required
				if ( record['valid'] && canContinue === false ) {
					canContinue = true;
				}
				if ( !record['valid'] ) {
					let count = 1;
					for(let column of record['errorColumns']){
						if(count > 1 && count == record['errorColumns'].length){
							errorMessage += ' and ';
							errorMessage += displayPropertiesMap[column.toLowerCase()];
							indicative = ' are '; // x and y columns *ARE* required
							break;
						}
						
						errorMessage += displayPropertiesMap[column.toLowerCase()];
						
						if(record['errorColumns'].length > 2){
							errorMessage += ', ';
						}
						
						count++;
					}
					
					errorMessage += indicative;
					errorMessage += 'required.';
					record['message'] = errorMessage;
				} else if ( !record['foundAccount'] ) {
					record['message'] = 'User account will be created';
				} else {
					record['message'] = 'Existing user found and will be updated';
				}
				
				formattedArray.push(record);
			}
			this.hasErrors = !canContinue;
	
			this.formattedResults = formattedArray;
		}
		
		
	}
	
}

export { AdminAccountImportController };